// name | tel | email | icon | address
const useContactPicker = () => {
  const isSupported = "contacts" in navigator && "ContactsManager" in window;

  const selectContacts = async (select = ["name", "tel"], multiple = false) => {
    if (!isSupported) throw new Error("Contacts API not supported!");
    const contacts = await navigator.contacts.select(select, { multiple });
    return contacts;
  };
  return { isSupported, selectContacts };
};

export default useContactPicker;
